import { useNavigate } from 'react-router-dom'
import { Bug } from 'lucide-react'

import WideButton from '@/components/common/button/WideButton'
import qbeeSadTransparent from '@/assets/images/qbee-character/qbee-happy-transparent.png'

const NotFoundPage = () => {
  const navigate = useNavigate()

  return (
    <div className='min-h-screen bg-gradient-to-r from-amber-400 to-yellow-300 flex items-center justify-center p-4'>
      <div className='max-w-md w-full text-center'>
        {/* 큐비 캐릭터 */}
        <div className='flex justify-center mb-8'>
          <img src={qbeeSadTransparent} alt='큐비 캐릭터' className='w-24 h-24' />
        </div>

        {/* 에러 메시지 */}
        <div className='bg-white/90 backdrop-blur rounded-2xl p-6 mb-6'>
          <h1 className='text-3xl font-bold text-amber-900 mb-2'>404</h1>
          <h2 className='text-xl font-bold text-gray-800 mb-3'>페이지를 찾을 수 없어요</h2>
          <p className='text-gray-600 leading-relaxed mb-4'>
            요청하신 페이지가 존재하지 않거나
            <br />
            잘못된 주소로 접근하셨어요.
          </p>
          <div className='flex items-center justify-center gap-2 text-sm text-amber-700'>
            <Bug className='w-4 h-4' />
            <span>길을 잃은 큐비가 되었네요!</span>
          </div>
        </div>

        {/* 버튼들 */}
        <div className='space-y-3'>
          <WideButton
            handleClick={() => navigate(-1)}
            buttonText='이전 페이지로'
            className='flex items-center justify-center gap-2'
          />
          <WideButton
            handleClick={() => navigate('/')}
            buttonText='홈으로 가기'
            className='bg-amber-500 hover:bg-amber-600 text-white border-amber-500 flex items-center justify-center gap-2'
          />
        </div>

        {/* 도움말 */}
        <div className='mt-6 text-sm text-white/80'>
          <p>문제가 계속되면 고객센터로 문의해주세요</p>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage
